import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=9b3a5dfa&scoped=true"
import script from "./verify-code.vue?vue&type=script&lang=js"
export * from "./verify-code.vue?vue&type=script&lang=js"
import style0 from "./verify-code.vue?vue&type=style&index=0&id=9b3a5dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3a5dfa",
  null
  
)

export default component.exports